import types from './types';
import {filterSearchResults} from "../../utils";

const initialState = {
	search: '',
	popupSearch: '',
	filters: {
		grade: [],
		location: [],
		dorm: [],
		gender: [],
		type: []
	},
	checkinFilters: {
		grade: [],
		location: [],
		dorm: [],
		gender: [],
		type: []
	},
	placeholder: 'Search Students',
	current: [],
	checkinCurrent: [],
	profile: {},
	students: [],
	checkinStudents: [],
	loading: true,
	rosterFilter: [],
	checkinRosterFilter: []
};



export default (state = initialState, action) => {
	switch (action.type) {
		/* Set search term  */
		case types.UPDATE_SEARCH: {
			// const {current} = state;
			// const newCurrent = filterByName(action.payload, current)
			return {
				...state,
				// current: newCurrent,
				search: action.payload
			};
		}

		/* Set Popup Message Search term  */
		case types.UPDATE_POPUP_SEARCH: {
			return {
				...state,
				popupSearch: action.payload
			};
		}

		// Clear search.
		case types.CLEAR_SEARCH: {

			return {
				...state,
				search: ""
			};
		}

		// Clear search.
		case types.CLEAR_POPUP_SEARCH: {
			console.log(' ------- clear------- ');
			return {
				...state,
				popupSearch: ""
			};
		}

		case types.UPDATE_FILTER:
			const newCurrent = filterSearchResults(action.payload, state.students);
			return {
				...state,
				current: newCurrent,
				filters: action.payload
			};
		// Clear search.
		case types.CLEAR_FILTER: {
			const {students} = state
			return {
				...state,
				current: students,
				filters: {
					grade: [],
					location: [],
					dorm: [],
					gender: [],
					type: []
				},
			};
		}
		case types.UPDATE_CHECKIN_FILTER: {
			const newCheckinCurrent = filterSearchResults(action.payload, state.students);
			return {
				...state,
				checkinCurrent: newCheckinCurrent,
				checkinFilters: action.payload
			};
		}
		// Clear search.
		case types.CLEAR_CHECKIN_FILTER: {
			const {students} = state
			return {
				...state,
				checkinCurrent: students,
				checkinFilters: {
					grade: [],
					location: [],
					dorm: [],
					gender: [],
					type: []
				},
			};
		}

		case types.CLEAR_CHECKIN_ROSTER_FILTER: {
			return {
				...state,
				checkinRosterFilter: []
			}
		}
		
		case types.UPDATE_STUDENTS: {
			const current = filterSearchResults(state.filters, action.payload);
			return {
				...state,
				current,
				loading: false,
				students: action.payload
			}
		}
		case types.UPDATE_CHECKIN_STUDENTS: {
			const current = filterSearchResults(state.checkinFilters, action.payload);
			return {
				...state,
				checkinCurrent: current,
				loading: false,
				checkinStudents: action.payload
			}
		}
		case types.UPDATE_PLACEHOLDER:
			return {
				...state,
				placeholder: action.payload
			}
		case types.CLEAR_PLACEHOLDER:
			return {
				...state,
				placeholder: "Search Students"
			}
		case types.UPDATE_ROSTER_FILTER:
			return {
				...state,
				rosterFilter: action.payload
			}
		case types.UPDATE_CHECKIN_ROSTER_FILTER:
			return {
				...state,
				checkinRosterFilter: action.payload
			}
		default:
			return state;
	}
};
